import { Component, OnInit,EventEmitter } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { delay } from 'rxjs/internal/operators/delay';
import { map } from 'rxjs/internal/operators/map';
import { switchMap } from 'rxjs/operators';
import { EventsService } from 'src/app/shared/services/events.service';
import { ClarityEventsService } from 'src/app/shared/services/clarity.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import { Store } from 'src/app/core/store/store';
import { EncryptionService } from '../../services/encryption.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: any;
  loading = false;
  submitted = false;
  returnUrl: string = '';
  error = '';
  passwordText = false;
  isSSOPartner = false;
  isMultipleLogin: boolean = false;
  ssoForm : any;

  errorMessages: any = {
    email: {
      required: "Email address is required",
      isEmailInvalid: "Please enter a valid email address.",
      // isEmailExists: `This email doesn't have a Harappa account."
    },
    password: {
      required: "Password is required"
    },
    SSOId : {
      required: "SSO Id is required",
      isSSOInvalid: "Please enter a valid SSO Id.",
    }
  }

  otherUserErr = false;
  domainUrl: string;
  isPasswordForgot:boolean=false;
  emailpatchValue="";
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private eventsService: EventsService,
    private clarityEventsService: ClarityEventsService,
    private toaster: ToastrService,
    private encryptionService: EncryptionService,
    private store:Store
  ) {
    this.loginForm = this.formBuilder.group({
      // email: [null, [Validators.required, this.validateEmail.bind(this)], this.isEmailExists.bind(this)],
      email: [null, [Validators.required, this.validateEmail.bind(this)]],
      password: [null, [Validators.required, Validators.minLength(8)]],
      role: null,
    });
    if(window.location.hostname === 'localhost'){
      this.loginForm.addControl('tokenType',new FormControl('4rf4ew'));
    }
    this.ssoForm = this.formBuilder.group({
      // email: [null, [Validators.required, this.validateEmail.bind(this)], this.isEmailExists.bind(this)],
      SSOId: [null, [Validators.required, this.validateEmail.bind(this)]]
    });
  }

  ngOnInit() {
    this.domainUrl = environment.businessDomain;
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    this.router.navigate([this.returnUrl]);
    this.loginForm.valueChanges.subscribe((val: any) => {
      if (val) {
        this.emailpatchValue=this.loginForm.get('email').value;
        this.error = '';
      }
    });

  }

  resendPassword(email){
    let data = { email:email }
    this.authService.passwordResetOTP(data).subscribe((res) => {
      if (res) {
        this.isPasswordForgot=false;
        this.toaster.success("We've sent your password reset link! Check your registered email ID.");
      }
    });
  }
  forgotPassword(val){
    this.isPasswordForgot=val;
    this.isSSOPartner = false;

  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
// ADD ENCRYPTION IN LOGIN
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    let opts = {
      email: this.encryptionService.encryptData(this.loginForm.value.email),
      password: this.encryptionService.encryptData(this.loginForm.value.password),
      role: null,
      tokenType: window.location.hostname === 'localhost' ? 'skipMultiLogin' : 'production'
    }
    // this.loginForm.value.email = this.encryptionService.encryptData(this.loginForm.value.email)
    // this.loginForm.value.password = this.encryptionService.encryptData(this.loginForm.value.password)
    this.authService.login(opts)
      .subscribe(
        (data) => {
          let clarityObj = {
            email: data.email,
            organization: data.organization,
            activationUniqueName: ''
          }
          this.clarityEventsService.adminRegister(clarityObj)
          // modification to be done after partner-dashboard integration
          if (data && (data['isIPJUser'] && (data['role'] == 'LEARNER'))) {
            this.store.set('user',data);
            (data['isPasswordResetRequired']) ? this.router.navigate(['/info-review']) : window.location.href = '/dashboard';
            try {
              this.eventsService.loginEvent(data);
            } catch (err) {
              console.log(err);
            }
          } else if (data && ((data['role'] == 'PARTNER_ADMIN') || (data['role'] == 'ADMIN'))) {
            (data['isPasswordResetRequired']) ? this.router.navigate(['/info-review']) : this.router.navigate(['/learning-insights']);
            try {
              this.eventsService.loginEvent(data);
            } catch (err) {
              console.log(err);
            }
          }
          else if (data && !data['isIPJUser']) {
            this.otherUserErr = true;
          }
        },
        (error) => {
          console.log(error, 'errorerror')
          if(error == 'Message: Multiple logins detected. Log out from the other device first.') {
            this.isMultipleLogin = true
          }
          if (error && error.error && error.error.msg) {
            this.error = error.error.msg;
          }
          this.loading = false;
        }
      );
  }

  logoutByEmail() {
    let opts = {
      email: this.loginForm.value.email
    }
    this.authService.logoutByEmail(opts).subscribe(res => {
      this.onSubmit()
    })
  }


  get email() { return this.loginForm.get('email'); }

  get password() { return this.loginForm.get('password'); }

  togglePassword() {
    this.passwordText = !this.passwordText;
  }

  validateEmail(control: FormControl) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(control.value) ? null : { isEmailInvalid: true }
  }

  private emailExistsValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return of(control.value).pipe(
        delay(500),
        switchMap((email) => this.authService.IsEmailExist(email).pipe(
          map(emailExists => !emailExists ? { isEmailExists: true } : null)
        ))
      );
    };
  }

  getErrorMessage(fieldName: string) {
    let errors = this.loginForm.get(fieldName).errors
    if (errors) return this.errorMessages[fieldName][Object.keys(errors)[0]]
  }
  getErrorMessageSSO(fieldName: string) {
    let errors = this.ssoForm.get(fieldName).errors
    if (errors) return this.errorMessages[fieldName][Object.keys(errors)[0]]
  }

  // isEmailExists(control: FormControl) {
  //   return this.authService.IsEmailExist(control.value).pipe(map(res => {
  //     return !res ? { isEmailExists: !res } : null
  //   }));
  // }

  navigateToMainSite() {
    window.open(`${environment.mainDomain}/auth/login`);
  }
  SSOSignIn(){
    try {
    this.isPasswordForgot=false;
      this.isSSOPartner = true;
    } catch (error) {
      console.log(error);
    }
  }
  SSOSignInCall(){
    let SSOIdValue = this.ssoForm.value.SSOId;
    console.log(SSOIdValue);
    this.authService.getByAcademyOrgId(SSOIdValue).subscribe((res) => {
      if (res && res['data'].length) {
        window.location.href = res['data'][0].callBackURL;
        this.isPasswordForgot=false;
        this.isSSOPartner = false;
      } else {
        // TODO document why this block is empty
        console.error(res);
      }
    });
  }
  tocaps(){
    this.ssoForm.get('SSOId').patchValue(this.ssoForm.get('SSOId').value.toUpperCase());
  }


}
